import {useState} from 'react'
import DashboardBox from '../../components/DashboardBox'
import DashboardSection from '../../components/Cards/DashboardSection'
import MakePaymentsTable from '../../components/Tables/MakePaymentsTable'
import {Modal} from 'react-bootstrap'
import EnterCreditCard from '../../pages/forms/EnterCreditCard'
import {MakePayment} from '../../components/Tables/MakePaymentsTable'

export default function MakePaymentsDashboard() {
  const title = 'Make Payment'

  const [show, setShow] = useState(false)
  const [currentAmount, setCurrentAmount] = useState('')
  const [prefix, setPrefix] = useState('')

  const onPay = (policy: MakePayment) => {
    console.log('PAY FROM PARENT', policy)
    setPrefix(policy.prefix)
    setCurrentAmount(parseFloat(policy.amount).toFixed(2))
    setShow(true)
  }

  return (
    <DashboardBox hasMobileFullWidth>
      <DashboardSection name={title} className='table_box_xl_device'>
        <MakePaymentsTable onPay={onPay} />
      </DashboardSection>

      <div className='table_box_mobile w-full'>
        <DashboardSection name={title}>
          <div className='w-full h-4' />
        </DashboardSection>
        <MakePaymentsTable displayForMobile onPay={onPay} />
      </div>

      {/* 🔥 ONE MODAL */}
      <Modal show={show} onHide={() => setShow(false)} dialogClassName='edit-code-dialog-modal'>
        <Modal.Header closeButton className='edit-code-modal'>
          <Modal.Title>Enter Payment Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className='edit-code-modal'>
          <EnterCreditCard closeModal={() => setShow(false)} currentAmount={currentAmount} prefix={prefix} />
        </Modal.Body>
      </Modal>
    </DashboardBox>
  )
}
